import React, {useState} from 'react';
import {convertItemImagePath, GET_METHOD, POST_METHOD, promiseCallApi} from "../../../../../stores/tools/commons";
import {
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  InputAdornment,
  NativeSelect,
  TextField,
  Typography
} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";

// actions
import { deleteCatalogCodes, changeCatalogCodes, resetCatalogCode } from '~/slices/items/itemSearchOption'
import { openBar } from '~/slices/commons/snackbar'

// components
import RenderTextField from "../../../../finalForms/atoms/RenderTextField";
import {Field} from "react-final-form";
import RenderSelectList from "../../../../finalForms/atoms/RenderSelectList";
import {monthList} from "../../../../../constants/commons";
import {getItemInfos} from "../../../../../services/api/cart";
import RoundedCornersButton from "../../../../atoms/roundedCornersButton";
import colorPalette from "../../../../../styles/theme/colorPalette";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import {narrowDown} from "../../../../../data/shop/itemSearchOption";
import {findCategoryLabel, findSubCategoryLabel, findWithSubCategoryLabel} from "../../../../../services/hooks/item";
import Image from "next/image";
import CloseBtn from '../../../../../../public/images/common/btn_close.svg'
import NeutralButton from "../../../../atoms/NeutralButton";
import DummyImage from "../../../../../../public/images/common/dummy_image.svg";

const InputCatalogCode = (props) => {
  const dispatch = useDispatch()
  const placeholder = 'data:image/gif;base64,R0lGODlhGQAZALMAAP///+fn58/Pz7m5uaGhoZ+fn52dnYmJiQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFBwAIACwCAAIAFQAVAAAERRDJSQG9+NrMa6cBtlFGFnpkd0ojUn7r+H7IKs10rn9C7wsZg3CI2xmPg0tBl5QQJstP00mJZqbU6hXzVOq6x2wYAc5EAAAh+QQFBwAIACwCAAIAEgASAAAELxDJSQO9WNrM0eYC9k0AFVZXeZ0apWLs92asNHd4jg18P+jAoJAgRBCHxWNQmYsAACH5BAUHAAgALAIAAgAVAAsAAAQoEMlJBb342sxrpwO2UUEWemR3SiNSfuv4fsgqzXSuf0TvExmAcAiIAAAh+QQFBwAIACwFAAIAEgASAAAELhDJiQa9WNrMa0cEtlECFVKjVF6nRnLtuMLX/N14fgV8H+jAIAIgHBaJQmRQGQEAIfkEBQcACAAsDAACAAsAFQAABCqQoEmrrPhiqung2Ad6GblN4qmup+C+AitXwQlQNXbjOpZPOxolaGMRNxEAIfkEBQcACAAsBQAFABIAEgAABC4QyUkpqbjezDfH3meJZGlyQ6oOZ0sClSDCUjDJGV1TOKXvPB/GFhMRW8dTEhMBACH5BAUHAAgALAIADAAVAAsAAAQnEMgJkL2I6E2w/2AojoE3jFdpCddJYmwrqlcsf3T9uaiNfr4fbBQBACH5BAkHAAgALAIAAgAVABUAAAQzEMlJq7046w227h4GhtZIUuaprlPgvgErz5ZQEaEtDROu6TuK7wIMCokW3i2kZDVXT0sEADs='
  const searchCatalogCodesState = useSelector((state) => state.itemSearchOption.searchCatalogCodes)
  
  const ids = Object.keys(searchCatalogCodesState).map((id) => Number(id))
  const minId = Math.min(...ids)
  
  const onBlurFunc = (e, key) => {
    if (e.target.value.length === 3) {
      const query = {
        code: e.target.value,
        num: 1
      }
      insertSearchCatalogCodes(query, key)
    }
  }
  
  const onChangeFunc = (e, key, code) => {
    if (code) {
      const query = {
        code: code,
        num: e.target.value
      }
      insertSearchCatalogCodes(query, key)
    }
  }
  
  const deleteField = (key) => {
    dispatch(deleteCatalogCodes(key))
  }
  
  const resetField = (key) => {
    dispatch(resetCatalogCode(key))
  }
  
  const insertSearchCatalogCodes = (query, key) => {
    const { code, num } = query
    getItemInfos(code, num).then(res => {
      const obj = {
        key: key,
        itemData: {
          name: res.data.itemData.name,
          item_code: res.data.itemData.item_code,
          code: res.data.itemData.code,
          num: res.data.num,
          price: res.data.itemData.price,
          discountPrice: res.data.itemData.discountPrice,
          majorCategoryCode: res.data.itemData.majorCategoryCode,
          categoryCode: res.data.itemData.categoryCode,
          result: res.data.result
        }
      }
      dispatch(changeCatalogCodes(obj))
    }).catch(() => {
      dispatch(openBar({message: '商品情報の取得に失敗しました', variant: 'error'}))
    })
  }
  
  return (
      <Box css={{maxWidth: '640px', margin: '0 auto'}}>
        <Container>
          <FormControl css={{width: '100%'}}>
            <div css={inputArea}>
              <Grid container spacing={1} alignItems={'center'}>
                <Grid item>
                  <TextField
                      type={'number'}
                      id={`catalogCode_${props.fieldId}`}
                      sx={{ m: 0, width: '20ch' }}
                      size={'small'}
                      css={{backgroundColor: colorPalette.background.lightgray}}
                      defaultValue={props.codeData.code && props.codeData.code.slice(-3) || ''}
                      onChange={(e) => onBlurFunc(e, props.fieldId)}
                      placeholder={'カタログ番号'}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">55 -</InputAdornment>,
                      }}
                  />
                </Grid>
                <Grid item flex={1}>
                  <div css={{maxWidth:'70px'}}>
                    <NeutralButton
                        text={'リセット'}
                        onClick={() => resetField(props.fieldId)}
                        maxWidth={'70px'}
                        hexColorCode={colorPalette.gray}
                        css={{
                          padding: '0.5rem'
                        }}
                    />
                  </div>
                </Grid>
                <Grid item>
                  {
                    props.fieldId != minId &&
                    <>
                      <CloseBtn fill={ '#484848' } css={closeBtnStyle} onClick={() => deleteField(props.fieldId)}/>
                    </>
                  }
                </Grid>
              </Grid>
        
              {
                props.codeData.code &&
                <div css={{borderTop: 'solid 1px #efefef', marginTop: '0.5rem', paddingTop: '1rem'}}>
                  <div>
                    <Grid container alignItems={'center'} flexWrap={'nowrap'}>
                      <Grid item css={itemImage}>
                        {
                          props.codeData.item_code &&
                          props.codeData.item_code !== 'selection' &&
                          <>
                            <Image src={ convertItemImagePath(props.codeData.item_code, 't1') } width={80} height={80} alt={name} loading={'lazy'} placeholder={'blur'} blurDataURL={placeholder}/>
                          </>
                          ||
                          <DummyImage fill='#efefef' css={{width:'100%',height:'100%'}}/>
                        }
                      </Grid>
                      <Grid container flexWrap={'wrap'} alignItems={'center'}>
                        <Grid item css={itemName}>
                          <CategoryTag color={props.codeData.majorCategoryCode}>
                            {
                              props.codeData.majorCategoryCode === 'selection' &&
                              'セット商品'
                              ||
                                  <>
                                    {
                                      `${findWithSubCategoryLabel(props.codeData.categoryCode)?.label}`
                                    }
                                  </>
                            }
                          </CategoryTag>
                          <div>
                            { props.codeData.name }
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>
                  <Grid container justifyContent={'flex-end'} alignItems={'center'}>
                    <Grid item css={stockBox}>
                      <span>在庫：</span>
                      {
                        props.codeData && props.codeData.result !== null &&
                        (props.codeData.result ? '◯' : '×')
                        ||
                        '-'
                      }
                    </Grid>
                    <Grid item css={priceBox}>
                            <span>¥ {
                              props.codeData &&
                              Number(props.codeData.discountPrice).toLocaleString()
                              ||
                              '-'
                            }</span>
                    </Grid>
                    <Grid item>
                      <NativeSelect
                          css={selectStyle}
                          defaultValue={props.codeData.num || 0}
                          inputProps={{
                            name: 'item-num',
                            id: 'uncontrolled-native',
                          }}
                          onChange={(e) => onChangeFunc(e, props.fieldId, props.codeData.code && props.codeData.code.slice(-3) || '')}
                      >
                        {
                          [...Array(19)].map((_, i) => i).map((i) => (
                              <option key={i+1} value={i+1}>{i+1}</option>
                          ))
                        }
                      </NativeSelect>
                    </Grid>
                  </Grid>
                </div>
              }
            </div>
          </FormControl>
        </Container>
      </Box>
  );
};

export default InputCatalogCode;

const inputArea = css`
  width: 100%;
  position: relative;
  border: solid 1px ${colorPalette.lightgray};
  border-radius: 8px;
  margin-top: 16px;
  padding: 8px;

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="number"] {
    -moz-appearance:textfield;
  }
`

const CategoryTag = styled.div({
  color: 'white',
  padding: '0 1rem',
  marginBottom: '0.2rem',
  fontSize: '1.2rem',
  display: 'inline-block',
  borderRadius: '4px',
}, props => ({
  backgroundColor: colorPalette.itemCategories[props.color],
}))

const itemImage = css`
  overflow: hidden;
  border-radius: 6px;
  max-width: 60px;
  max-height: 60px;
`

const itemName = css`
  padding: 0 1rem;
  flex: 1;
  min-width: 200px;
  margin-bottom: 8px;
`

const closeBtnStyle = css`
  //position: absolute;
  margin-top: 4px;
  //right: 4px;
  width: 2.3rem;
  cursor: pointer;
`

const stockBox = css`
  flex-basis: 8rem;
  padding-left: 1rem;
`

const priceBox = css`
  flex-basis: 6rem;
  padding-left: 1rem;
`

const selectStyle = css`
  border-radius: 4px;
  padding: 0 0 0 1rem;
  margin-left: 1rem;
  background-color: ${colorPalette.background.lightgray};
  &:before {
    border: none;
  }
`